app.controller('BrowsePropertyComponentController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.componentModel = $rootScope.factory.component.getModel($scope.navigation_ids);

    let selectedComponentID = $rootScope.navigation_model.state_ids.component_id; //todo. Would navigationIDs work and does this work?

    let otherChoiceList = [];

    function createOtherChoiceList() {
        otherChoiceList = [];
        const fromChoiceList = $scope.componentModel.choiceList();
        if (!selectedComponentID) {
            return;
        }
        for (let i = 0; i < fromChoiceList.length; i++) {
            const choice = fromChoiceList[i];
            if (choice.id === selectedComponentID) {
                continue;
            }
            otherChoiceList.push(choice);
        }
    }

    createOtherChoiceList();


    $scope.otherChoiceList = function () {
        const stateIDs = $rootScope.navigation_model.state_ids;
        if (stateIDs.component_id !== selectedComponentID) {
            selectedComponentID = stateIDs.component_id;
            createOtherChoiceList();
        }
        return otherChoiceList;
    }


}])